import React from 'react';
import { ElementConfigType } from '../../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import style from './TextYellow.module.scss';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../../HOC';

type Props = ElementConfigType;

export const TextYellowTitleComponent: MyComponentType<Props> = (props: Props) => {
  const { id, privateSchema, config, parentNodeIsBody } = props;
  return (
    <div
      className={style.textYellow}
      style={Object.assign(parentNodeIsBody ? { paddingTop: 16, paddingBottom: 16 } : {})}
      id={id}
    >
      <h2
        style={{
          fontSize: privateSchema?.fontSize,
          fontWeight: privateSchema?.fontWeight,
          color: privateSchema?.color,
          lineHeight: `${privateSchema?.lineHeight}px`,
        }}
        className="left-yellow-color-block text-black font-bold text-xl left-color-block hover:bg-opacity-10"
      >
        {privateSchema?.text || config?.text}
      </h2>
    </div>
  );
};

const ConfigForm = lazy(() => import('../../components-with-definition/TextYellowTitleComponentDefinition'));

TextYellowTitleComponent.definition = {
  // id: 'text-yellow-title-component',
  id: ComponentIdEnum.TEXT_YELLOW_TITLE_COMPONENT,
  name: '标题文本组件_2',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/M4aPyg2ayUK6Vkt_s9Yir.png?image_process=resize,w_200',
  position: 6, // 显示顺序
  config: {
    text: 'Assembly Video',
  },
  privateSchema: {
    text: 'Assembly Video',
    fontSize: 20, // 16
    fontWeight: 700,
    // eslint-disable-next-line @iceworks/best-practices/recommend-add-line-height-unit
    lineHeight: 28, // 24
  },
  category: 'text',
  configForm: ConfigHOC(ConfigForm),
};
